<div class="" style="padding: 0 60px;">
    <!-- <div class="row mt-3 border-bottom">
        <div class="col-11">
            <h6 style="color: #126db3;margin-left:-15px">
                {{"action_plan.plan_development.title" | translate}}
            </h6>
        </div>
        <div class="col-1  d-flex justify-content-end" (click)="openPrimary()" style="padding-top: 10px;">
            <i *ngIf="!primaryOpen" class="fas fa-chevron-down text-secondary"
                style="cursor: pointer;margin-left:19px"></i>
            <i *ngIf="primaryOpen" class="fas fa-chevron-up text-secondary"
                style="cursor: pointer;margin-left:19px"></i>
        </div>
    </div> -->
    <ng-container *ngIf="primaryOpen">
        <!-- <div class="row mt-4 mb-2">
            <div class="col-12 col-lg-8">
                <h6 style="color: #126db3;margin-left:-15px"> {{"action_plan.plan_development.action" | translate}}</h6>
            </div>
            <div class="col-12 col-lg-4 d-flex justify-content-end ">
                <div class="input-group search-input">
                    <input class="form-control" placeholder="{{'globals.search'  | translate}}" type="text"
                        [(ngModel)]="search" />

                    <div class="input-group-append search-bar">
                        <span class="input-group-text search"><i class="fas fa-search"></i></span>
              

                    </div>
                </div>
                <i *ngIf="!secondaryOpen" class="fas fa-chevron-down text-secondary" (click)="openSecondary()"
                    style="cursor: pointer;margin-left:19px;margin-top:10px"></i>
                <i *ngIf="secondaryOpen" class="fas fa-chevron-up text-secondary" (click)="openSecondary()"
                    style="cursor: pointer;margin-left:19px;margin-top:10px"></i>
            </div>
        </div> -->
        <div class="row bg-white p-3 contenedor" *ngIf="secondaryOpen">
            <div class="col-12">
                <!-- <div class="row">
                    <div class="col-8 d-flex flex-row">

                        <span class="fa-stack fa-1x cursor" style="font-size: 13px;">
                            <i class="fa fa-circle fa-stack-2x icon-background"></i>
                            <i class="fas fa-chevron-left fa-stack-1x" style="left:-2px"></i>
                        </span>
                        <span class="fa-stack fa-1x ml-lg-4 cursor" style="font-size: 13px;">
                            <i class="fa fa-circle fa-stack-2x icon-background"></i>
                            <i class="fas fa-chevron-right fa-stack-1x" style="right:-2px"></i>
                        </span>
                        <span class="fa-stack fa-1x ml-lg-4 cursor" style="font-size: 13px;">
                            <i class="fa fa-circle fa-stack-2x icon-background"></i>
                            <i class="fas fa-chevron-up fa-stack-1x" style="top:-1px"></i>
                        </span>
                        <span class="fa-stack fa-1x ml-lg-4 cursor" style="font-size: 13px;">
                            <i class="fa fa-circle fa-stack-2x icon-background"></i>
                            <i class="fas fa-chevron-down fa-stack-1x" style="top:1px"></i>
                        </span>

                    </div>
                    <div class="col-4 d-flex flex-row-reverse">
                        <div class="mr-2">
                            <span class="fa-stack fa-1x ml-lg-2 cursor" style="font-size: 13px;"
                                (click)="addNewAction()">
                                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                                <i class="fas fa-plus fa-stack-1x"></i>
                            </span>
                            <span class="fa-stack fa-1x ml-2 cursor" style="font-size: 13px;">
                                <i class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                <i class="fas fa-times fa-stack-1x"></i>
                            </span>

                        </div>

                    </div>
                </div> -->
                <div class="row mt-2">
                    <div class="col-lg-3" style="color: #126db3;" *ngIf="smallSize">
                        <div class="row">
                            <div class="col-2">
                                <span class=""
                                    style="margin-left:17px">{{"action_plan.plan_development.nbr" | translate}}</span>
                            </div>
                            <div class="col-10">
                                <span class="ml-3">{{"action_plan.plan_development.task" | translate}} <i
                                        class="fas fa-sort text-secondary ml-1" style="cursor: pointer;"></i></span>
                            </div>
                        </div>


                    </div>
                    <div class="col-lg-3" style="color: #126db3;" *ngIf="smallSize">
                        <span>{{"action_plan.plan_development.responsible" | translate}} <i
                                class="fas fa-sort text-secondary ml-1" style="cursor: pointer;"></i></span>
                    </div>
                    <div class="col-lg-2" style="color: #126db3;" *ngIf="smallSize">
                        <span style="margin-left: 4px;">{{"action_plan.plan_development.plan_date" | translate}} <i
                                class="fas fa-sort text-secondary ml-1" style="cursor: pointer;"></i></span>

                    </div>
                    <div class="col-lg-2" style="color: #126db3;" *ngIf="smallSize">
                        <span style="margin-left: -6px;">{{"action_plan.plan_development.stage" | translate}} <i
                                class="fas fa-sort text-secondary ml-1" style="cursor: pointer;"></i></span>

                    </div>
                    <div class="col-lg-2" style="color: #126db3;" *ngIf="smallSize">
                        <div class="align-title-estado">
                            <span>{{"action_plan.plan_development.state" | translate}} <i
                                    class="fas fa-sort text-secondary ml-1" style="cursor: pointer;"></i></span>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <form action="" style="width: 100%;">


                        <ng-container *ngIf="listData.length">

                            <ng-container
                                *ngFor="let data of listData | search:search:modulo; index as i; first as isFirst">
                                <div class="col-12 p-2 form-grey">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="col-12" *ngIf="!smallSize" style="color: #126db3;">
                                                <div class="row">
                                                    <div class="col-1">
                                                        <span
                                                            class="">{{"action_plan.plan_development.nbr" | translate}}</span>
                                                    </div>
                                                    <div class="col-11">
                                                        <span
                                                            class="">{{"action_plan.plan_development.task" | translate}}</span>
                                                        <span class=""><i class="fas fa-sort text-secondary ml-1"
                                                                style="cursor: pointer;"></i></span>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-2">
                                                        <div class="custom-control custom-checkbox">
                                                            <input type="checkbox" class="custom-control-input"
                                                                [(ngModel)]="data.checked" name="{{i}}">
                                                            <label class="custom-control-label" for="customCheck1">
                                                                {{i+1}}</label>
                                                        </div>
                                                    </div>


                                                    <div class="col-10">

                                                        <div class="align">
                                                            {{data.tarea}}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-lg-3">
                                            <div class="col-12" *ngIf="!smallSize" style="color: #126db3;">
                                                <span>{{"action_plan.plan_development.responsible" | translate}}</span>
                                                <span class=""><i class="fas fa-sort text-secondary ml-1"
                                                        style="cursor: pointer;"></i></span>
                                            </div>
                                            <div class="col-12">
                                                <div class="align-resp">
                                                    <ng-container *ngFor="let resp of data.responsable">
                                                        {{resp.usuario_organizacion?.usuario.name}}
                                                    </ng-container>

                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-lg-2">
                                            <div class="col-12" *ngIf="!smallSize" style="color: #126db3;">
                                                <span>{{"action_plan.plan_development.plan_date" | translate}}</span>
                                                <span class=""><i class="fas fa-sort text-secondary ml-1"
                                                        style="cursor: pointer;"></i></span>
                                            </div>
                                            <div class="col-12">
                                                <div class="align_fecha">
                                                    {{data.fecha_fin}}
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-lg-2">
                                            <div class="col-12" *ngIf="!smallSize" style="color: #126db3;">
                                                <span
                                                    class="ml-lg-4">{{"action_plan.plan_development.stage" | translate}}</span>
                                                <span class=""><i class="fas fa-sort text-secondary ml-1"
                                                        style="cursor: pointer;"></i></span>
                                            </div>
                                            <div class="col-12">
                                                <div class="align_etapa">
                                                    <ng-container *ngIf="data.etapa=='No tratado'">
                                                        <i class="fas fa-square mr-1"
                                                            style="color:white"></i>{{"action_plan.plan_development.states.not_treated" |
                                                            translate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="data.etapa=='Notificado'">
                                                        <i class="fas fa-square mr-1"
                                                            style="color:yellow"></i>{{"action_plan.plan_development.states.notification" |
                                                            translate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="data.etapa=='Planificado'">
                                                        <i class="fas fa-square mr-1"
                                                            style="color:orange"></i>{{"action_plan.plan_development.states.planned" |
                                                            translate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="data.etapa=='En ejecución'">
                                                        <i class="fas fa-square mr-1"
                                                            style="color:greenyellow"></i>{{"action_plan.plan_development.states.execution" |
                                                            translate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="data.etapa=='Ejecutado'">
                                                        <i class="fas fa-square mr-1"
                                                            style="color:green"></i>{{"action_plan.plan_development.states.executed" |
                                                            translate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="data.etapa=='Validado'">
                                                        <i class="fas fa-square mr-1"
                                                            style="color:blue"></i>{{"action_plan.plan_development.states.validation" |
                                                            translate}}
                                                    </ng-container>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-lg-2">
                                            <div class="col-12" *ngIf="!smallSize" style="color: #126db3;">
                                                <div class="align-title-estado">
                                                    <span
                                                        class="">{{"action_plan.plan_development.state" | translate}}</span>
                                                    <span class=""><i class="fas fa-sort text-secondary ml-1"
                                                            style="cursor: pointer;"></i></span>
                                                </div>

                                            </div>
                                            <div class="col-12 d-flex justify-content-between">
                                                <div class="align_estado">
                                                    <ng-container *ngIf="data.estado=='En fecha'">
                                                        <i class="fas fa-square mr-1"
                                                            style="color:greenyellow"></i>{{"action_plan.plan_development.states.on_date" |
                                                            translate}}
                                                    </ng-container>
                                                    <ng-container *ngIf="data.estado=='No en fecha'">
                                                        <i class="fas fa-square mr-1"
                                                            style="color:red"></i>{{"action_plan.plan_development.states.not_on_date" |
                                                            translate}}
                                                    </ng-container>

                                                </div>

                                                <div class="d-flex">
                                                    <span class="text-secondary mr-2 cursor"><i *ngIf="data.details"
                                                            class="fas fa-chevron-up" (click)="openInside(i)"></i>
                                                        <i *ngIf="!data.details" class="fas fa-chevron-down"
                                                            (click)="openInside(i)"></i>
                                                    </span>

                                                    <span class="fa-stack fa-1x cursor mr-2" style="font-size: 13px;">
                                                        <i
                                                            class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                                        <i class="fas fa-times fa-stack-1x"></i>
                                                    </span>
                                                    <!-- <span class="fa-stack fa-1x cursor" 
                                                        style="font-size: 13px;margin-top:-1px">
                                                        <i class="fa fa-circle fa-stack-2x icon-background"></i>
                                                        <i class="pda-icon historic fa-stack-1x"></i>
                                                    </span> -->
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-lg-2 d-flex">
                                    <div class="col-12 invisible" *ngIf="!smallSize" style="color: #126db3;">
                                        <span class="fa-stack fa-1x ">
                                            <i class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                            <i class="fas fa-times fa-stack-1x"></i>
                                        </span> <span class="circle acceptButton"><i class="fas fa-plus"></i></span>
                                    </div>
                                    <div class="col-12 d-flex justify-content-between">
                                        <span class="text-secondary"><i class="fas fa-chevron-up"></i></span>
        
                                        <span class="fa-stack fa-1x" style="font-size: 13px;">
                                            <i class="fa fa-circle fa-stack-2x icon-background dangerIcon"></i>
                                            <i class="fas fa-times fa-stack-1x"></i>
                                        </span>
                                    </div>
        
                                </div> -->
                                        <div class="col-12 p-3 mt-2" *ngIf="data.details">
                                            <app-action-form [data]="{selected:planSelected,action:data}" [nro]="i+1"
                                                (emitChangeSelected)="changeSelected($event)" [disabled]="true">
                                            </app-action-form>
                                        </div>
                                    </div>


                                </div>
                            </ng-container>
                        </ng-container>

                        <!-- <ng-container *ngIf="newAction">
                            <div class="col-12  form-grey py-2">
                                <div class="row">

                                    <div class="col-12">
                                        <form action="" [formGroup]="datosNewAction">
                                            <div class="form-row">
                                               
                                                <div class="col-12 d-flex">
                                                    <div class="custom-control custom-checkbox check-new">
                                                        <input type="checkbox" class="custom-control-input">
                                                        <label class="custom-control-label" for="customCheck1">
                                                            {{dataSource.length+1}}</label>
                                                    </div>
                                                    <div class="input-group search-input">

                                                        <input class="form-control" type="text" formControlName="tarea"
                                                            [ngClass]="{ 'error': datosNewAction.get('tarea').hasError('required')  &&
                                                    datosNewAction.get('tarea').touched }" />
                                                        <div class="input-group-append ">
                                                            <span class="input-group-text">
                                                                <span class="fa-stack fa-1x cursor"
                                                                    style="font-size: 13px;" (click)="addNew()">
                                                                    <i
                                                                        class="fa fa-circle fa-stack-2x icon-background"></i>
                                                                    <i class="fas fa-check fa-stack-1x"></i>
                                                                </span>
                                                            </span>

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>


                            </div>
                        </ng-container> -->
                    </form>
                </div>
            </div>

            <!-- <div class="col-12 col-md-8 ml-auto mt-3 mt-lg-5 btns d-flex p-0 flex-row-reverse">

                <button class="btn  m-2 mainColor text-white" style="font-size: 14px;">
                    {{"action_plan.plan_development.bitacora" | translate}}
                </button>
                <button class="btn  m-2 acceptButton text-white" (click)="returnToActives()" style="font-size: 14px;">
                    REACTIVAR
                </button>

            </div> -->
        </div>
    </ng-container>
</div>